import { useContext } from "react";
import { GableSide } from "../../models/GableSide";
import { GableType } from "../../models/GableType";
import { IMaterial } from "../../services/WebApiClient";
import { EditorContext } from "../EditorCommon/EditorContext";
import { MaterialSelector } from "../EditorCommon/MaterialSelector";


export function SingleGableEditor(props: {
    gableSide: GableSide,
    onClose?: (() => void)
}) {

    const ec = useContext(EditorContext);

    var materials = ec.cabinetService.getGableMaterials(props.gableSide);
    var currentId = props.gableSide === GableSide.Left
        ? ec.cabinet.leftGableMaterialId
        : ec.cabinet.rightGableMaterialId;

    const gableInfo = ec.cabinetService.getGableInfo();
    const side = props.gableSide === GableSide.Left
        ? gableInfo.left
        : gableInfo.right;

    function setGableMaterial(mat: IMaterial) {
        ec.cabinetService.setGableMaterialId(mat.id, props.gableSide);
    }

    return (
        <div className="single-gable-editor">
            <h3>
                {side.type === GableType.Gable
                    ? ec.translator("doors gable header gable", "Gavl")
                    : ec.translator("doors gable header sidePanel", "Anslag")}
            </h3>
            <MaterialSelector materials={materials}
                currentId={currentId ?? undefined}
                onSelect={setGableMaterial}
                header={ec.translator("doors gable material", "Materiale")}
            />
        </div>
    );
}
